const t = {}

t.loading = 'Loading...'

t.brand = {}
t.brand.lg = 'RPP Management System'
t.brand.mini = 'RPP'

t.add = 'Add'
t.copy = 'Copy'
t.delete = 'Delete'
t.deleteBatch = 'Delete'
t.on = 'Active'
t.off = 'Disable'
t.update = 'Edit'
t.query = 'Query'
t.export = 'Export'
t.handle = 'Action'
t.confirm = 'Confirm'
t.cancel = 'Cancel'
t.logout = 'Sign Out'
t.agree = 'Agree'
t.refuse = 'Refuse'
t.prohibit = 'Prohibit'
t.enable = 'Enable'
t.multiplexing = 'Reuse'
t.save = 'Confirm'

// uploader组件的配文
t.uploader = {};
t.uploader.error = 'An error occurred while uploading';
t.uploader.sizeError = 'Do not upload empty files';
t.uploader.imgError = 'Please pass in the picture!';
t.uploader.pdfError = 'Please pass in the PDF file!';
t.uploader.pdfSizeExceed = 'The file size cannot exceed 10M!';
t.uploader.plzUpload = 'Please upload a picture';
t.uploader.drop1 = 'Drop file here, or '
t.uploader.drop2 = 'Click to upload'

t.prompt = {}
t.prompt.title = 'Prompt'
t.prompt.info = 'Confirm to [{handle}]?'
t.prompt.success = 'Succeeded'
t.prompt.failed = 'Failed'
t.prompt.deleteBatch = 'Please select delete item'
t.prompt.logout = 'Do you cancel your current account ?'

t.message = {}
t.message.logoutCancel = 'Abandoning logout users'

t.validate = {}
t.validate.required = 'Required field cannot be empty'
t.validate.fillEng = 'Please fill in Letter'
t.validate.contentLong = 'Too long in content'
t.validate.format = '{attr} format error'
t.validate.choose = 'Please choose'

t.upload = {}
t.upload.text = 'Drop files here, or <em>Click Upload</em>'
t.upload.tip = 'Only support {format} format files! '
t.upload.button = 'Click to upload'
t.upload.selectFile = 'Select File'
t.upload.exceed = 'Upload beyond limit'
t.upload.editCotentText = 'Please edit the content'
t.upload.recommandCarousel = 'The recommended size is 1130px × 640px, and the size does not exceed 500KB';
t.upload.recommandAdvert = 'The recommended size is 2130px × 750px, and the size does not exceed 5M';
t.upload.recommandLv1 = 'Recommended size is more than 800px × 800px, png, jpg format'
t.upload.recommandLv1Ad = 'The recommended size is more than 560X240px, png, jpg format, not exceed 5M'
t.upload.recommandLv3 = 'The recommended size is more than 800X800px, png, jpg format, no more than 5M'
t.upload.recommandBrandHomeAdvert = 'The recommended size is 920px × 400px, and the size does not exceed 5M';
t.upload.recommandBrandDetailAdvert = 'The recommended size is 1438px × 400px, and the size does not exceed 5M';
t.upload.recommandHighlightActivity = 'The recommended size is 1396px × 800px, and the size does not exceed 500KB';
t.upload.recommandLOGIN = 'The recommended size is 370px × 800px, and the size does not exceed 500KB';
t.upload.recommandREGISTER = 'The recommended size is 1440px × 240px, and the size does not exceed 500KB';
t.upload.recommandREGISTER_SUCCESS = 'The recommended size is 560px × 320px, and the size does not exceed 500KB';
t.upload.recommandPopUp = 'The recommended size is 800px × 800px, png, jpg format, and the size does not exceed 5MB';

t.datePicker = {}
t.datePicker.range = 'To'
t.datePicker.start = 'Start Date'
t.datePicker.end = 'End Date'
t.timePicker = {}
t.timePicker.start = 'Start Time'
t.timePicker.end = 'End Time'

t.fullscreen = {}
t.fullscreen.prompt = 'Your browser does not support this operation'

t.updatePassword = {}
t.updatePassword.title = 'Change Password'
t.updatePassword.username = 'Account'
t.updatePassword.password = 'Original'
t.updatePassword.newPassword = 'New Password'
t.updatePassword.comfirmPassword = 'Confirm'
t.updatePassword.validate = {}
t.updatePassword.validate.comfirmPassword = 'Confirm password is not consistent with new password input'

t.theme = {}
t.theme.d2 = 'D2Admin Classic'
t.theme.violet = 'Violet'
t.theme.line = 'Line'
t.theme.star = 'Star'
t.theme.tomorrowNightBlue = 'Tomorrow Night Blue'
t.theme.list = {}
t.theme.list.button = 'Select'
t.theme.list.buttonActive = 'Activated'

t.layout = {}
t.layout.hello = 'Hello'
t.layout.logout = 'Logout'
t.layout.updatePassword = 'Update Password'
t.layout.tooltip = {}
t.layout.tooltip.fullscreen = 'Fullscreen'
t.layout.tooltip.fullscreenActive = 'Exit Fullscreen'
t.layout.tooltip.theme = 'Theme'
t.layout.tooltip.search = 'Search'
t.layout.search = {}
t.layout.search.placeholder = 'Search Pages'
t.layout.search.tip1 = 'Press'
t.layout.search.tip2 = 'open search panel, and press'
t.layout.search.tip3 = 'close it.'

t.layoutTab = {}
t.layoutTab.index = 'Home'
t.layoutTab.noName = 'No Name'

t.contentTabs = {}
t.contentTabs.closeCurrent = 'Close Current Tab'
t.contentTabs.closeOther = 'Close Other Tabs'
t.contentTabs.closeAll = 'Close All Tabs'

/* pages */
t.notFound = {}
t.notFound.desc = 'Sorry! <em>missing</em> on the page you visited...'
t.notFound.back = 'Previous Page'
t.notFound.home = 'Home'

t.login = {}
t.login.language = 'Language'
t.login.motto = 'Time is the most precious treasure of all wealth'
t.login.form = {}
t.login.form.placeholderUsername = 'username'
t.login.form.placeholderPassword = 'password'
t.login.form.placeholderCaptcha = 'Captcha'
t.login.form.textSubmitButton = 'Sign In'
t.login.form.textForget = 'Forget'
t.login.form.textSignUp = 'Sign up'
t.login.footer = {}
t.login.footer.buttonHelp = 'Help'
t.login.footer.buttonPrivacy = 'Privacy'
t.login.footer.buttonClause = 'Clause'
t.login.copyright = {}
t.login.copyright.p1 = 'Copyright'
t.login.copyright.p2 = '2018 D2 Projects Open Source Organizational'
t.login.copyright.p3 = '@FairyEver'
t.login.ruleMessage = {}
t.login.ruleMessage.username = 'User name must be entered'
t.login.ruleMessage.password = 'Password must be entered'
t.login.ruleMessage.captcha = 'Captcha must be entered'

/* home */
t.home = {}
t.home.daily = 'Daily Update',
    t.home.sales = 'Today Sales',
    t.home.numberOfOrder = 'Today Orders',
    t.home.numberOfUser = 'Current Users',
    t.home.newUser = 'New Users',
    t.home.assetsIncome = 'Income Record',
    t.home.totalSales = 'Total Sales',
    t.home.last30DaySales = 'Last 30 Days Sales',
    t.home.transactionManagement = 'Transaction Management',
    t.home.toDeliver = 'Waiting Delivery',
    t.home.refund = 'Completed Order',
    t.home.waitingConfirm = 'Waiting Confirm',
    t.home.inventoryWarn = 'Inventory Warn'
t.home.inventoryWarnDefaultValue = 'Inventory Warn Default Value'
t.home.inventoryQueryTime = 'Inventory Query Time'

/*商品 */
t.product = {}
t.product.name = 'Product Name'
t.product._ = 'Product'
t.product._id = 'Product ID'
t.product.list = 'Product List'
t.product.describe = 'Product Description'
t.product.operation = 'Main Product Action'
t.product.detailPage = 'Product Information'
t.product.detailPageContent = 'Product Info'
t.product.detailPageEdited = 'Edited'
t.product.detailPageUnedited = 'Unedited'
t.product.skuType = 'Attribute Type'
t.product.addRow = 'Add a row'
t.product.info = 'Info'
t.product.notice = 'Notice'
t.product.manufacturer = 'Manufacturer'
t.product.supplier = 'Supplier'
t.product.selectionReasons = 'Selection Reasons'
t.product.item = {}
t.product.item._ = 'ProductItem'
t.product.item.list = 'ProductItem List'
t.product.item.keyword = 'Keyword'
t.product.item.activate = 'Activate'
t.product.item.id = 'Platform ID'
t.product.item.name = 'ProductItem Name'
t.product.item.describe = 'Describe'
t.product.item.barCode = 'BarCode'
t.product.item.code = 'SKU'
t.product.item.stock = 'Stock'
t.product.item.price = 'Promotion Price'
t.product.item.agentPrice = 'Agent Price'
t.product.item.projectPrice = 'Project Price'
t.product.item.originalPrice = 'SRP Price'
t.product.item.operation = 'Sub Product Action'
t.product.item.off = 'Off'
t.product.item.on = 'On'
t.product.item.copy = 'Duplicate'
t.product.item.freightCalculate = 'Freight Calculate'
t.product.item.freightCalculateValue = 'Freight Calculate Value'
t.product.item.weight = 'Weight'
t.product.item.volume = 'Volume'
t.product.item.big = 'Big'
t.product.item.priceAndStock = 'Price & Stock'
t.product.item.pictureAndVideo = 'Picture & Video'
t.product.item.picture = 'Picture (1)'
t.product.item.detailPicture = 'Picture Details (6)'
t.product.item.video = 'Video (1)'
t.product.item.extendValue = 'Color Code'
t.product.item.colorPicker = 'Color Picker'
t.product.item.increment = 'Increment'
t.product.item.attribute = 'Attribute'
t.product.item.attributeValue = 'Attribute Value'
t.product.item.attributeName = 'Attribute Name'
t.product.item.inventoryWarnValue = 'Inventory Warn Value'
t.product.item.salesVolume = 'Sales volume'
t.product.item.shopLogo = 'Shop Logo'
t.product.shelfTime = 'Shelf time (starting)'
t.product.setuprecproducts = 'Set up recommended products'
t.product.Confirmscreening = 'Confirm screening'
t.product.filtersText1 = 'Nearly 30 days'
t.product.filtersText2 = 'Nearly 60 days'
t.product.filtersText3 = 'Nearly three months'
t.product.filtersText4 = 'Nearly 6 months'
t.product.filtersText5 = 'Nearly 12 months'
t.product.Historicalsales = 'Historical sales'

/* 订单 */
t.order = {}
t.order.id = 'Order ID'
t.order.traceNo = 'Order Trace Number'
t.order.amount = 'Order Amount(฿)'
t.order.amountFlag = '฿'
t.order.status = 'Order Status'
t.order.WC = 'Wait Confirm'
t.order.WP = 'Waiting Pay'
t.order.WS = 'Waiting Delivery'
t.order.WR = 'Waiting Receive'
t.order.FINISH = 'Finish'
t.order.CANCEL = 'Cancel'
t.order.REFUNDING = 'Refunding'
t.order.REFUNDED = 'Refunded'
t.order.RETURNED = 'Refunded'
t.order.REJECTED = 'Rejected'
t.order.userPhone = 'User Phone'
t.order.paymentMethod = 'Payment Method'
t.order.cashPay = 'Cash Pay'
t.order.onlinePay = 'Online Pay'
t.order.cod = 'COD'
t.order.shippingMethod = 'Shipping Method'
t.order.pickUp = 'Pick Up'
t.order.delivery = 'Delivery'
t.order.time = 'Order Time'
t.order.finishedTime = 'Finished Time'
t.order.payTime = 'Pay Time'
t.order.count = 'Count'
t.order.toPay = 'To Pay'
t.order.toShip = 'To Ship'
t.order.finishOrder = 'Finish Order'
t.order.invoice = 'Invoice'
t.order.cancelOrder = 'Cancel Order'
t.order.detail = 'Detail'
t.order.party = 'Courier'
t.order.trackingNumber = 'Tracking Number'
t.order.flashStatus = 'Status'
t.order.expressNumber = 'Tracking No.'
t.order.expressTime = 'Time'
t.order.expressInfo = 'Info'
t.order.zto = 'ZTO'
t.order.companyName = 'Company Name'
t.order.companyCode = 'Company Code'
t.order.placeOrder = 'Place Order'
t.order.payment = 'Payment'
t.order.deliver = 'Deliver'
t.order.complete = 'Complete'
t.order.collector = 'Collector'
t.order.collectAmount = 'Collect Amount'
t.order.collectTime = 'Collect Time'
t.order.receivingInfo = 'Receiving Information'
t.order.phone = 'Phone'
t.order.address = 'Address'
t.order.zipCode = 'Zip Code'
t.order.invoice = 'Invoice'
t.order.electronic = 'Electronic'
t.order.paper = 'Paper'
t.order.refund = 'Refund'
t.order.refundId = 'Refund ID'
t.order.agree = 'Agree'
t.order.refuse = 'Refuse'
t.order.refundProduct = 'Refund Product'
t.order.refundType = 'Refund Type'
t.order.delivered = 'Delivered'
t.order.processMethod = 'Process Method'
t.order.refundReason = 'Refund Reason'
t.order.refundRemarks = 'Refund Remarks'
t.order.receivableAmount = 'Receivable Amount(฿)'
t.order.receivedAmount = 'Received Amount(฿)'
t.order.remark = 'Order remark'
t.order.refundState = 'Refund status: refund completed '
t.order.refundId = 'Refund ID'
t.order.refundType = 'Refund type'
t.order.refundMethod = 'Processing mode'
t.order.remarks = 'Refund reason'
t.order.refundReason = 'Refund instruction'
t.order.goodsStatus = 'Arrival'
t.order.refundTypeEXCHANGE = 'Exchange goods'
t.order.refundTypeLEAKAGE = 'Missing hair'
t.order.refundTypeREFUND = 'refund'
t.order.goodsStatusDELIVERED = 'YES'
t.order.goodsStatusUNDELIVERED = 'Not yet arrived'
t.order.refundMethodREFUND = 'refund'
t.order.refundMethodRETURN = 'Return goods'
t.order.refundMethodREFUNDANDRETURN = 'Return refund'
t.order.refundMethodREISSUED = 'Replacement'
t.order.refundReasonNOTCONFORM = 'Description discrepancy'
t.order.refundReasonWRONGDELIVERY = 'Wrong delivery'
t.order.refundReasonQUALITY = 'quality problem'
t.order.refundReasonOTHER = 'Other'
t.order.childOrderId = 'Child Order Id'
t.order.mechantName = 'Mechant Name'
t.order.productImage = 'Product Image'
t.order.code = 'Code'
t.order.productName = 'Product Name'
t.order.productPrice = 'Product Price'
t.order.productTotal = 'Total'
t.order.productStatus = 'Status'
t.order.operation = 'Operation'
t.order.shipTime = 'Ship Time'
t.order.viewLogistics = 'View Logistics'
t.order.discountPrice = 'Discount Price'
t.order.freightPrice = 'Freight Price'
t.order.productPrice = 'Product Price'
t.order.subOrderDetail = 'Sub Order Detail'
t.order.coreOrderId = 'Order ID'
t.order.allDatail = 'Total Order Detail'
t.order.walletPaid = 'Amount of wallet received'
t.order.codPrice = 'COD Receivable'
t.order.codPaid = 'COD received'
t.order.onlinePaid = 'Online payment received'
t.order.rejectOrder = 'Reject'
t.order.reasonCode = 'Reason Code'
t.order.reasonMsg = 'Reason Message'
t.order.Paymentvoucher = 'Payment voucher'
t.order.FirstPaymentvoucher = 'First payment voucher:'
t.order.Uploadtime = 'Upload time:'
t.order.ProofPaymentvoucher = 'Proof of final payment:'
t.order.piclargetip = '*The size must not exceed 3MB, the format is png, jpg, jpeg'
t.order.picerror = 'Picture format error'
t.order.piclarge = 'The picture is too large'

/* 统计 */
t.statistical = {}
t.statistical.type = 'Type'
t.statistical.date = 'Date'
t.statistical.amount = 'Amount(฿)'
t.statistical.orders = 'Orders'
t.statistical.dailyReport = 'Daily Report'
t.statistical.monthlyReport = 'Monthly Report'
t.statistical.annualReport = 'Annual Report'

/* 广告 */
t.advert = {}
t.advert.name = 'Advert Name'
t.advert.jumpType = 'Jump Type'
t.advert.noJump = 'No Jump'
t.advert.productItemDetail = 'ProductItem'
t.advert.share = 'Share'
t.advert.classification = 'Classification'
t.advert.login = 'Login'
t.advert.wallet = 'Wallet'
t.advert.buyfree = 'BUYFREE'
t.advert.buyfreeDetail = 'BUYFREEDETAIL'
t.advert.activityId = 'Activity ID'
t.advert.productItemID = 'ProductItem ID'
t.advert.priority = 'Priority'
t.advert.periods = 'Periods'
t.advert.ONCEADAY = 'Once a day'
t.advert.EVERYTIME = 'Everytime'
t.advert.ONLYONCE = 'Once'
t.advert.effectiveDate = 'Effective Date'
t.advert.effective = 'Effective'
t.advert.activity = 'Activity'
t.advert.monopoly = 'Monopoly'
t.advert.merchant = 'Shop'
t.advert.brand = 'Brand'


/* 佣金 */
t.commission = {}
t.commission.userName = 'User Name'
t.commission.newUserName = 'New User Name'
t.commission.oldUserName = 'Old User Name'
t.commission.newUserCountry = 'New User Country'
t.commission.oldUserCountry = 'Old User Country'
t.commission.presentMoney = 'Present Money(฿)'
t.commission.status = 'Status'

t.menu = {}
t.menu.name = 'Name'
t.menu.icon = 'Icon'
t.menu.type = 'Type'
t.menu.type0 = 'Menu'
t.menu.type1 = 'Button'
t.menu.sort = 'Sort'
t.menu.url = 'Route'
t.menu.permissions = 'Auth ID'
t.menu.permissionsTips = 'Multiple separated by commas, such as: sys:menu:save,sys:menu:update'
t.menu.parentName = 'Superior'
t.menu.parentNameDefault = 'Top Menu'
t.menu.resource = 'Auth Resources'
t.menu.resourceUrl = 'Resource URL'
t.menu.resourceMethod = 'Request Method'
t.menu.resourceAddItem = 'Add an Item'
t.menu.label = {}
t.menu.label.closeLeft = 'Close Left'
t.menu.label.closeRight = 'Close Right'
t.menu.label.closeOther = 'Close Other'
t.menu.label.closeAll = 'Close All'


t.role = {}
t.role.name = 'Name'
t.role.remark = 'Remarks'
t.role.createDate = 'Create Date'
t.role.menuList = 'Menu Scope'
t.role.deptList = 'Data Scope'

/* user */
t.user = {}
t.user.username = 'User Name'
t.user.deptName = 'Department'
t.user.email = 'Email'
t.user.mobile = 'Mobile'
t.user.status = 'Status'
t.user.status0 = 'Disable'
t.user.status1 = 'Enable'
t.user.createDate = 'Create Date'
t.user.password = 'Password'
t.user.comfirmPassword = 'Confirm'
t.user.realName = 'Real Name'
t.user.gender = 'Gender'
t.user.gender0 = 'Male'
t.user.gender1 = 'Female'
t.user.gender2 = 'Secure'
t.user.roleIdList = 'Role Config'
t.user.validate = {}
t.user.validate.comfirmPassword = 'Confirm password is not consistent with password input'
t.user.country = 'Country'
t.user.name = 'Name'
t.user.level = 'Level'
t.user.balance = 'Balance'
t.user.userType = 'User type'
t.user.company = 'Company'
t.user.individual = 'Individual'
t.user.level0 = 'Unset'
t.user.level2 = 'Plus Level'
t.user.level1 = 'Pro Level'
t.user.level3 = 'Starter Level'
t.user.level4 = 'Fans Level'
t.user.level5 = 'Vip Level'
t.user.level10 = 'Pro Price - Cash'
t.user.level11 = 'Pro Price - Credit'
t.user.level20 = 'Plus Price - Cash'
t.user.level21 = 'Plus Price - Credit'
t.user.level30 = 'Starter Price - Cash'
t.user.level31 = 'Starter Price - Credit'
t.user.level40 = 'Fans Level - Cash'
t.user.level41 = 'Fans Level - Credit'
t.user.level50 = 'Vip Level - Cash'
t.user.level51 = 'Vip Level - Credit'

t.user.usable = 'Usable'
t.user.cash = 'Cash'
t.user.present = 'Present'
t.user.freeze = 'Freeze'
t.user.point = 'Point'
t.user.logout = 'Logout'
t.user.loginPassword = 'Login Password'
t.user.revoke = 'Revoke'
t.user.grant = 'Grant'
t.user.usernameTip = 'Please enter user name'

/* 钱包 */
t.wallet = {}
t.wallet.amount = 'Amount(฿)'
t.wallet.auditAdmin = 'Audit Admin'
t.wallet.auditTime = 'Audit Time'
t.wallet.finishAdmin = 'Finish Admin'
t.wallet.inProgress = 'Pending review'
t.wallet.agree = 'Pending transfer'
t.wallet.refuse = 'Not Approved'
t.wallet.finish = 'Finish'
t.wallet.agreeButton = 'Agree'
t.wallet.refuseButton = 'Refuse'
t.wallet.transferButton = 'Transfer completed'
t.wallet.Remarks = 'Remarks'
t.wallet.configwithdraw = 'Confirm consent to withdraw?'
t.wallet.configtransfer = 'Whether to confirm the transfer?'
t.wallet.denialReason = 'Denial Reason'
t.wallet.viewInfo = 'View transfer information'
t.wallet.bankName = 'Bank Name'
t.wallet.Account = 'Account'
t.wallet.name = 'Name'

/* 权限 */
t.power = {}
t.power.role = 'Role'
t.power.roleName = 'Role Name'
t.power.menu = 'Menu'

/* 系统 */
t.sys = {}
t.sys.apk = {}
t.sys.apk.title = 'Title'
t.sys.apk.content = 'Content'
t.sys.apk.versionName = 'Version Name'
t.sys.apk.versionCode = 'Version Code'
t.sys.apk.pkg = 'Pkg'
t.sys.apk.mandatoryUpdate = 'Mandatory Update'
t.sys.apk.file = 'File'
t.sys.apk.all = "All"
t.sys.apk.cearch = "search"
t.sys.apk.version = "New version"
t.sys.apk.codeTip = "Version name"
t.sys.apk.mandatoryUpdateTip = "Whether to force updates-all"
t.sys.apk.client = "Client-all"
t.sys.apk.yes = 'Yes'
t.sys.apk.no = 'No'
t.sys.apk.uploadTime = 'Update time'
t.sys.apk.kehutype = 'Client'
t.sys.apk.mandatoryUpdate = 'Whether to force updates'
t.sys.apk.status = 'status'
t.sys.apk.apkoperation = 'APK operations'
t.sys.apk.forceButton = 'Set to force update version'
t.sys.apk.forceNoButton = 'Set as non mandatory update version'
t.sys.apk.deleteButton = 'Delete version'
t.sys.apk.reuploadButton = 're-upload'
t.sys.apk.modifyButton = 'Modify'
t.sys.apk.updateDescription = 'Update description'

t.sys.dict = {}
t.sys.dict.key = 'Key'
t.sys.dict.value = 'Value'
t.sys.dict.hint = 'Hint'
t.sys.dict.search = 'Key/Value/Hint'

t.sys.multilingual = {}
t.sys.multilingual.search = 'English/Thai'

t.sys.cache = {}
t.sys.cache.refreshAllCache = 'Refresh All Cache'
t.sys.cache.refreshActivityCache = 'Refresh Activity Cache'
t.sys.cache.refreshTagCache = 'Refresh Tag Cache'
t.sys.cache.refreshCarouselCache = 'Refresh Carousel Cache'
t.sys.cache.refreshCategoryCache = 'Refresh Category Cache'
t.sys.cache.refreshNewCategoryCache = 'Refresh New Category Cache'

t.sys.cache.refreshActivityCacheSuccess = 'Refresh activity cache success'
t.sys.cache.refreshTagCacheSuccess = 'Refresh tag cache success'
t.sys.cache.refreshCarouselCacheSuccess = 'Refresh cache successful'
t.sys.cache.h5refreshCarouselCache = 'Refresh H5 homepage cache'
t.sys.cache.refreshCategoryCacheSuccess = 'Refresh category cache success'
t.sys.cache.refreshNewCategoryCacheSuccess = 'Refresh new category cache success'

t.sys.cache.refreshProductCache = 'Refresh product cache'
t.sys.cache.refreshSearchCache = 'Refresh search cache'
t.sys.cache.refreshProductCacheSuccess = 'Refresh product cache success'
t.sys.cache.refreshSearchCacheSuccess = 'Refresh search cache success'

/**目录**/
t.catalog = {}
t.catalog.CATEGORY = 'Category'
t.catalog.NEW_CATEGORY = 'Category'
t.catalog.ACTIVITY = 'Activity'
t.catalog.TAG = 'Tag'
t.catalog.modifySort = 'Modify Sort'
t.catalog.show = 'Show'
t.catalog.isConfirmDelete = 'Delete'

/**图表**/
t.charts = {}
t.charts.dailyUsers = 'Daily Users'
t.charts.hourlyUsers = 'Hourly Users'
t.charts.total = 'Total'
t.charts.shareCount = 'Share Count'
t.charts.shareRate = 'Share Rate'
t.charts.dailyOrders = 'Daily Orders'
t.charts.totalCount = 'Total Count'
t.charts.totalAmount = 'Total Amount'
t.charts.finishedCount = 'Finished Count'
t.charts.finishedTotalAmount = 'Finished Total Amount'
t.charts.finishedRate = 'Finished Rate'

/**赠品管理**/
t.activities = {};
t.activities.hint = 'Hint';
t.activities.switchStateHint = 'Activate the giveaway?';
t.activities.switchStateHint2 = '(Once the event is activated, the event information cannot be modified)';
t.activities.dupTemplate1 = ' participated in the activity ';
t.activities.dupTemplate2 = 'Please confirm whether to continue adding?';
t.activities.action = 'Action'
t.activities.tNo = '/'
t.activities.tName = 'Activity Name'
t.activities.tTime = 'Creation time'
t.activities.tTimeType = 'Time type'
t.activities.tStartTime = 'Start time'
t.activities.tEndTime = 'End time'
t.activities.tReviewState = 'State'
t.activities.tActiveState = 'Activity state'
t.activities.tActNotstart = 'Not started'
t.activities.tActPending = 'In progress'
t.activities.tActDisable = 'Disabled'
t.activities.tActOutdate = 'Outdated'
t.activities.tOper = 'Operation'
t.activities.qStartDate = 'Start Date'
t.activities.qEndDate = 'End Date'
t.activities.qReviewState = 'Review State'

t.activities.form = {};
t.activities.form.editLimit = 'Please create an activity before doing anything else'
t.activities.form.nameEn = 'Activity name (EN)'
t.activities.form.nameTh = 'Activity name (Th)'
t.activities.form.activityHint = 'Please enter the promotion name'
t.activities.form.dayStart = 'Start Time'
t.activities.form.dayKeep = 'Duration (day)'
t.activities.form.timeline = 'Promotion time'
t.activities.form.ever = 'Permanent'
t.activities.form.day = 'Days'
t.activities.form.date = 'Date'
t.activities.form.range = 'Scope of use'
t.activities.form.allUser = 'All user'
t.activities.form.someUser = 'Some user'
// t.activities.form. = ''
// t.activities.form. = ''
// t.activities.form. = ''

t.activities.form.search = 'Product name / Barcode'
t.activities.form.canAdd = 'Can be added'
t.activities.form.add = 'Add'
t.activities.form.addAll = 'Add all'
t.activities.form.added = 'Added'
t.activities.form.remove = 'remove'
t.activities.form.removeAll = 'Remove all'

t.activities.user = {}
t.activities.user.title = 'Basic Information'
t.activities.user.searchUser = 'Username'
t.activities.user.searchCom = 'Company name'
t.activities.user.searchUslv = 'User Level'
t.activities.user.username = 'Username'
t.activities.user.company = t.activities.user.searchCom
t.activities.user.level = 'User level'
t.activities.user.level1 = 'DROPSHIP'
t.activities.user.level2 = 'CASH'
t.activities.user.level3 = 'CREDIT'
t.activities.user.payType = 'User Flow'
t.activities.user.email = 'Contact'
t.activities.user.status = 'Status'
t.activities.user.statusY = 'Normal'
t.activities.user.statusN = 'Disabled'
t.activities.user.userType = 'User Type'

t.activities.product = {}
t.activities.product.title = 'Commodity information'
t.activities.product.img = 'Image'
t.activities.product.productName = 'Product name'
t.activities.product.search = 'Product name/Barcode'
t.activities.product.barcode = 'Barcode'
t.activities.product.price = 'Price'
t.activities.product.stock = 'Stock'
t.activities.product.skuSfx = 'SKU splice value'
t.activities.product.publish = 'Publish status'
t.activities.product.publishOn = 'On shelf'
t.activities.product.publishOff = 'Off shelf'
t.activities.product.hoverHint = 'The text enclosed in orange in the figure below is the text to be filled in'
t.activities.product.giftText = 'Gift Text'
t.activities.product.giftTextHintEng = 'Gift Text(En)'
t.activities.product.giftTextHintTh = 'Gift Text(Th)'

t.activities.gift = {}
t.activities.gift.title = 'Gift information'
t.activities.gift.img = 'Image'
t.activities.gift.productName = 'Product name'
t.activities.gift.search = 'Product name/Barcode'
t.activities.gift.barcode = 'Barcode'
t.activities.gift.price = 'Price'
t.activities.gift.publish = 'Publish status'
t.activities.gift.publishOn = 'On shelf'
t.activities.gift.publishOff = 'Off shelf'
t.activities.gift.stock = 'Stock'
t.activities.gift.limit = 'Gift quantity limit'

t.activities.advertName = 'Advert Name'
t.activities.pic = 'Advert Pic'
t.activities.createTime = 'Create Time'
t.activities.sort = 'Sort'
t.activities.status = 'Status'

/**组合商品**/
t.conbine = {}
t.conbine.switchStateHint = 'Activate the activity?';
t.conbine.switchStateHint2 = '(Once the event is activated, the event information cannot be modified)';
t.conbine.productInfo = 'Product Information'
t.conbine.tNo = '/'
t.conbine.tName = 'Activity Name'
t.conbine.tTime = 'Creation time'
t.conbine.tTimeType = 'Time type'
t.conbine.tStartTime = 'Start time'
t.conbine.tEndTime = 'End time'
t.conbine.tReviewState = 'State'
t.conbine.tActiveState = 'Activity state'
t.conbine.tActNotstart = 'Not started'
t.conbine.tActPending = 'In progress'
t.conbine.tActDisable = 'Disabled'
t.conbine.tActOutdate = 'Outdated'
t.conbine.tOper = 'Operation'
t.conbine.productInfo = 'Product Information'
t.conbine.oldPrice = 'Original price of bundle'
t.conbine.price = 'Bundle price'
t.conbine.discount = 'Discount'
t.conbine.dropShip = 'Pro Level Amount'
t.conbine.kd = 'Plus Level Amount'
t.conbine.dealer = 'Starter Level Amount'
t.conbine.fans = 'Fans Level Amount'
t.conbine.vip = 'VIP Level Amount'
t.conbine.limit = 'Stock limit'
t.conbine.hintProducts = 'Please select two or more products'
t.conbine.hintNoPrice = 'Please enter a price'
t.conbine.hintHighPrice = 'Discount price cannot be greater than original price'
t.conbine.hintLowPrice = 'The amount is incorrect'

/**折扣**/
t.discount = {}
t.discount.activityId = 'Campaign ID'
t.discount.activityName = 'Campaign'
t.discount.activityProfile = 'Campaign Dispaly'
t.discount.activityTag = 'Activity Tag'
t.discount.activate = 'Activate'
t.discount.activateOn = 'On'
t.discount.activateOff = 'Off'
t.discount.durationTime = 'Duration Time'
t.discount.brand = 'Brand'
t.discount.brandName = 'Brand Name'
t.discount.brandProfile = 'Brand Profile'
t.discount.brandInitials = 'Brand Initials'
t.discount.brandLogo = 'Brand Logo'
t.discount.startTime = 'Start Time'
t.discount.endTime = 'End Time'
t.discount.productItemPicture = 'ProductItem Picture'
t.discount.relationActivitys = 'Relation Activitys'
t.discount.assure = 'Brand Assure'
t.discount.address = 'Shipping Address'
t.discount.tips = 'Tips'
t.discount.deliveryTimeTips = 'Delivery Time Tips'
t.discount.paymentType = 'Payment Type Tips'
t.discount.deliveryTimePicture = 'Delivery Time Picture'
t.discount.paymentTypePicture = 'Payment Type Picture'
t.discount.allPriceAdjustment = 'All Price Adjustment'
t.discount.calculateType = 'Calculate Type'
t.discount.calculateValue = 'Discount Rate'
t.discount.timeSetting = 'Time Setting'
t.discount.deleteSetting = 'Delete'
t.discount.shopName = 'Shop name'
t.discount.productName = 'Product name/item name/ID'
t.discount.skuNum = 'SKU quantity'
t.discount.baseBigPic = 'Activities Big Image'
t.discount.Setrecord = 'Set record'
t.discount.Currentsetting = 'Current setting'
t.discount.texttopleft = 'Brand discount page display'
t.discount.texttopright = 'Products below discount'
t.discount.textconleft = 'Brand new product page display'
t.discount.day = 'day'
t.discount.textconright = 'Merchandise on shelves'
t.discount.textbotleft = 'Brand discount page display settings'
t.discount.inputtipone = 'Please enter the discount number'
t.discount.inputtiptwo = 'Please enter the number of days'
t.discount.tableone = 'Discount display value(%)'
t.discount.tabletwo = 'New product display days (days)'
t.discount.tabletime = 'Set time'
t.discount.tablepeopen = 'Operator'

/**会员**/
t.member = {}
t.member.account = 'Member Account'
t.member.relatedCreateTime = 'Related Create Time'
t.member.status = 'Status'
t.member.yStatus = 'Binding'
t.member.nStatus = 'Abnormal'
t.member.lowerMemberAccount = 'Lower Member Account'
t.member.obtainAmount = 'Obtain Amount'
t.member.unbinding = 'Unbinding'
t.member.amount = 'Amount'
t.member.superiorMemberAccount = 'Superior Member Account'
t.member.superiorAmount = 'Superior Amount'
t.member.invitationCode = 'Invitation Code'
t.member.copyInvitationCodeSuccess = 'Copy Successful. The Currently Copied Invitation Code Is '
t.member.copyInvitationCodeFailed = 'Copy Failed'
t.member.rewardName = 'Reward Name'
t.member.rewardAmount = 'Amount'
t.member.rewardCreateTime = 'Time'
t.member.rewardStatus = 'Status'
t.member.rewardAmountAccount = 'Amount Account'
t.member.yRewardStatus = 'Normal'
t.member.nRewardStatus = 'Abnormal'
t.member.uRewardStatus = 'Unknown'
t.member.newComerAward = 'Newcomer Award'
t.member.pullNewAward = 'Pull New Award'
t.member.rewardRecord = 'Reward Record'
t.member.firstOrderAward = 'First Order Award'
t.member.Numberaccounts = 'Number of sub accounts'
t.member.invitedBy = 'Invited by'
t.member.Enteraccountname = 'Enter sub account name'

/**拉新**/
t.pullnew = {}
t.pullnew.currentSetting = 'Current Setting'
t.pullnew.unlimitedDuration = 'Unlimited Duration'
t.pullnew.newComerAwardAmount = 'NewComer Award Amount (New Users)'
t.pullnew.pullNewAwardAmount = 'Pull New Award Amount (Old Users)'
t.pullnew.bindNewComerCount = 'Bind NewComer Count'
t.pullnew.newComerAwardAmountCount = 'NewComer Award Count'
t.pullnew.pullNewAwardAmountCount = 'Pull New Award Count'
t.pullnew.totalAmountCount = 'Total'
t.pullnew.queryMore = 'Show Detail'
t.pullnew.statistics = 'Statistics'
t.pullnew.modifySettings = 'Modify Settings'
t.pullnew.modifySettingsNum = 'Times'
t.pullnew.allBindNewComerCount = 'Bind NewComer Count'
t.pullnew.showBeforeDetail = 'Show History'
t.pullnew.newcomerAmount = 'Newcomer Amount'
t.pullnew.pullNewAmount = 'Pull New Amount'
t.pullnew.totalAmount = 'Total Amount'
t.pullnew.bindingPullNewActivityEffective = 'Binding PullNew Activity Effective'
t.pullnew.bindingNewcomerActivityEffective = 'Binding Newcomer Activity Effective'
t.pullnew.remark = 'Remark'
t.pullnew.cancel = 'Cancel'
t.pullnew.confirmModify = 'Confirm'
t.pullnew.pastRecord = 'Past Record'
t.pullnew.time = 'time'

/**分享活动**/
t.member.share = {}
t.member.share.tipSmallWordSetting = 'Tip Small Word Setting'
t.member.share.promptContentSetting = 'Prompt Content Setting'
t.member.share.contentSetting = 'Content Setting'
t.member.share.isShow = 'Whether to display'

/**buyfree管理(旧)**/
t.buyfree = {}
t.buyfree.add = 'Add Buyfree'
t.buyfree.productName = 'Product Name'
t.buyfree.itemId = 'Platform ID'
t.buyfree.itemPicture = 'Picture'
t.buyfree.itemName = 'ProductItem Name'
t.buyfree.code = 'Code'
t.buyfree.brandName = 'Brand Name'
t.buyfree.brandLogo = 'Brand Logo'
t.buyfree.rule = 'Rule'
t.buyfree.startTime = 'Start Time'
t.buyfree.endTime = 'End Time'
t.buyfree.numberOfParticipants = 'Number Of Participants'
t.buyfree.invitationsNumber = 'Invitations Number'
t.buyfree.stock = 'Stock'
t.buyfree.status = 'Status'
t.buyfree.inProgress = 'In Progress'
t.buyfree.closed = 'Closed'
t.buyfree.itemOff = 'Off'
t.buyfree.details = 'Details'
t.buyfree.activityTime = 'Activity Time'
t.buyfree.pullNewOnly = 'Pull New Only'
t.buyfree.pullNewNumber = 'Pull New Number'
t.buyfree.coExistWithPullNew = 'Co-Exist With PullNew'
t.buyfree.isNewPull = 'Is New Pull'
t.buyfree.isParallel = 'Is Parallel'
t.buyfree.ruleDescription = 'Rule Description'
t.buyfree.pageRuleDescription = 'Page Rule Description'
t.buyfree.activityOff = 'Activity Off'
t.buyfree.todayNewParticipantsNumber = 'Today New Participants Number'
t.buyfree.totalNumber = 'Total Number'
t.buyfree.totalPullNewNumber = 'Total Pull New Number'
t.buyfree.totalReward = 'Total Reward'
t.buyfree.rewardedUsers = 'Rewarded Users'
t.buyfree.surplusStock = 'Surplus Stock'
t.buyfree.userName = 'User Account'
t.buyfree.participateTime = 'Participate Time'
t.buyfree.completion = 'Completion'
t.buyfree.lastPullNewTime = 'Last Pull New Time'
t.buyfree.userAccount = 'User Account'
t.buyfree.activityPullNewDetails = 'Activity Pull New Details'
t.buyfree.binddingTime = 'Bindding Time'
t.buyfree.buyfreeType = 'Buyfree Type'
t.buyfree.buyfreeTypeForBuyfreeKey = 'Buyfree'
t.buyfree.buyfreeTypeForBuyfreeDraw = 'Shake'



/**
 * 摇一摇
 */
t.shake = {}
t.shake.add = 'Add Shake'
t.shake.shakeData = 'Data'
t.shake.shakeRule = 'Rule'
t.shake.next = 'Next'
t.shake.before = 'Before'
t.shake.activityData = 'Activity Data'
t.shake.activityName = 'Activity Name'
t.shake.logo = 'LOGO'
t.shake.coverLogo = 'Cover Logo'
t.shake.ruleDescription = 'Rule Description'
t.shake.defaultData = 'Default Data'
t.shake.backgroundPicture = 'Background Picture'
t.shake.shakePicture = 'Shake Picture'
t.shake.decorationPicture = 'Decoration Picture'
t.shake.shakeGIF = 'Shake GIF'
t.shake.notWinningText = 'Not Winning Text'
t.shake.winningText = 'Winning Text'
t.shake.notWinningPicture = 'Not Winning Picture'
t.shake.winningSmallPicture = 'Winning Small Picture'
t.shake.notWinningSmallPicture = 'Not Winning Small Picture'
t.shake.settingPrize = 'Setting Prize'
t.shake.prizeType = 'Prize Type'
t.shake.prizeName = 'Prize Name'
t.shake.prizeLevel = 'Prize Level'
t.shake.prizeCount = 'Prize Count'
t.shake.baseWinningRate = 'Base Winning Rate'
t.shake.setTimeWinningRate = 'Set Time Winning Rate'
t.shake.tips = 'Tips'
t.shake.remark = 'Remark'
t.shake.setTime = 'Set Time'
t.shake.addTimes = 'Add Times'
t.shake.lotteryNumber = 'Lottery Number'
t.shake.lotteryAllNumber = 'Lottery All Number'
t.shake.personEverydayLotteryNumber = 'Person Everyday Lottery Number'
t.shake.personAllLotteryNumber = 'Person All Lottery Number'
t.shake.inputCount = 'Input Count'
t.shake.productItem = 'Product Item'
t.shake.wallet = 'Wallet'
t.shake.amount = 'Amount'
t.shake.addPrize = 'Add Prize'
t.shake.addMoney = 'Add Money'
t.shake.sort = 'Sort'
t.shake.awardType = 'Award Type'
t.shake.awardTypeNORMAL = 'NORMAL'
t.shake.awardTypeSINGLE_MUTEX = 'SINGLE MUTEX'
t.shake.awardTypeMULT_MUTEX = 'MULT MUTEX'
t.shake.awardTypeALL_MUTEX_DAY = 'ALL MUTEX DAY'
t.shake.ruleName = 'Rule Name'
t.shake.havekey = 'Active Key'
t.shake.key = 'Key'
t.shake.closeAndReset = 'Close Will Empty Unsaved Data'
t.shake.chooseRule = 'Choose Rule'
t.shake.chooseRuleType1 = 'All Time'
t.shake.chooseRuleType2 = 'Custom Time'
t.shake.chooseRuleType3 = 'Day Time'
t.shake.chooseRuleType4 = 'Date Time'
t.shake.limitAwardTimes = 'Limit Award Times'
t.shake.ruleContent = 'Rule Content'
// t.shake.tips = 'Please pull right to see if the rules are completed!'


/** 轮播视频 */
t.video = {}
t.video.name = 'Video Name'
t.video.video = 'Video'
t.video.Collapse = 'Collapse'
t.video.createTime = 'Create Time'
t.video.remark = 'Remark'
t.video.sort = 'Sort'
t.video.status = 'Status'
t.video.itemOff = 'Unpublish'
t.video.itemOn = 'Publish'
t.video.delete = 'Delete'
t.video.description = 'Description'
t.video.statusShow = 'Show'
t.video.statusHide = 'Hide'
t.video.upload = 'Video Upload'
t.video.uploadEx = 'Video upload failed, please re-upload'
t.video.noSupport = 'Your browser does not support video playback'
t.video.noUpload = 'Please upload a video'

/** 新首页 */

/** 标签 */
t.homepage = {}
t.homepage.carousel = 'HomePage Carousel'
t.homepage.tags = 'HomePage Tag'
t.homepage.activities = 'Activities'
t.homepage.jumpEditor = 'Jump Editor'
t.homepage.taglist = {}
t.homepage.taglist.id = 'Tag ID'
t.homepage.taglist.tagName = 'Tag Name'
t.homepage.taglist.icon = 'Icon'
t.homepage.taglist.createTime = 'Create Time'
t.homepage.taglist.jumpType = 'Jump Type'
t.homepage.taglist.remark = 'Remark'
t.homepage.taglist.contentQuantity = 'Content Quantity'
t.homepage.taglist.sort = 'Sort'
t.homepage.taglist.status = 'Status'
t.homepage.taglist.inProgress = 'In Progress'
t.homepage.taglist.closed = 'Closed'
t.homepage.taglist.off = 'Off'
t.homepage.taglist.itemOff = 'Unpublish'
t.homepage.taglist.itemOn = 'Publish'
t.homepage.taglist.cancelRelated = 'Cancel Related'
t.homepage.taglist.modifySort = 'Modify Sort'
t.homepage.taglist.content = 'Content'
t.homepage.taglist.engIcon = 'Icon(EN)'
t.homepage.taglist.thIcon = 'Icon(TH)'
t.homepage.taglist.jumpTypeForMONOPOLY = 'MONOPOLY'
t.homepage.taglist.jumpTypeForH5 = 'H5'
t.homepage.taglist.jumpTypeForURL = 'Url'
t.homepage.taglist.jumpTypeForBUYFREE = 'BUYFREE'
t.homepage.taglist.jumpTypeForBUYFREEDETAIL = 'BUYFREEDETAIL'
t.homepage.taglist.jumpTypeForMEMBER = 'MEMBER'
t.homepage.taglist.jumpTypeForWALLTE = 'WALLTE'
t.homepage.taglist.jumpTypeForLOGIN = 'LOGIN'
t.homepage.taglist.typeItemId = 'Type ID'
t.homepage.taglist.addContent = 'Add Content'
t.homepage.taglist.contentAdded = 'Content Added'
t.homepage.taglist.addProduct = 'Add Product'
t.homepage.taglist.addedProductItem = 'Added Product'
t.homepage.taglist.ableAddProductItem = 'Product Can Be Added'
t.homepage.taglist.addSpecialActivities = 'Add Special Activitiy'
t.homepage.taglist.addedSpecialActivity = 'Added Special Activity'
t.homepage.taglist.ableAddSpecialActivity = 'Able Add Special Activity'
t.homepage.taglist.addAdvertising = 'Add Advertising'
t.homepage.taglist.addHotSaleProduct = 'Add Hot-Sale Product'
t.homepage.taglist.add = 'Add'
t.homepage.taglist.remove = 'Remove'
t.homepage.taglist.Allremove = 'All remove'
t.homepage.activity = {}
t.homepage.activity.logo = 'LOGO'
t.homepage.activity.remark = 'Remark'
t.homepage.activity.title = 'Title'
t.homepage.activity.sku = 'SKU'
t.homepage.activity.stock = 'Stock'
t.homepage.activity.attribute = 'Attribute'
t.homepage.activity.attributeValue = 'Attribute value'
t.homepage.activity.backgroundPicture = 'Background Picture'
t.homepage.activity.tag = 'Tag'
t.homepage.activity.type = 'Type'
t.homepage.activity.sort = 'Sort'
t.homepage.activity.status = 'Status'
t.homepage.activity.advert = 'Advert'
t.homepage.activity.hotsales = 'Hotsales'
t.homepage.activity.product = 'Product Item'
t.homepage.activity.activity = 'Activity'
t.homepage.activity.activityPicture = 'Activity Picture'
t.homepage.activity.tagSort = 'Tag Sort'
t.homepage.activity.tagStatus = 'Tag Status'
t.homepage.activity.isHomePage = 'Is HomePage'
t.homepage.activity.homePageSort = 'HomePage Sort'
t.homepage.activity.statusEnable = 'Enable'
t.homepage.activity.statusDisable = 'Disable'
t.homepage.activity.bulkOperations = 'Bulk Operations, Selected'
t.homepage.content = {}
t.homepage.content.baseInfo = 'Basic information'
t.homepage.content.adv = 'Advertising image'
t.homepage.content.advname = 'Name (not shown)'
t.homepage.content.sort = 'Sort'
t.homepage.content.position = 'Ad Position'
t.homepage.content.jump = 'Jump'
t.homepage.content.products = 'Homepage products'
t.homepage.content.status = 'Status'

t.homepage.hotsale = {}
t.homepage.hotsale.name = 'Name'
t.homepage.hotsale.engBackgroundPicture = 'Background Picture(EN)'
t.homepage.hotsale.thBackgroundPicture = 'Background Picture(TH)'
t.homepage.specialactivity = {}
t.homepage.specialactivity.logo = 'LOGO'
t.homepage.specialactivity.name = 'Name'
t.homepage.specialactivity.brandTitle = 'Brand Title'
t.homepage.specialactivity.title = 'Title'
t.homepage.specialactivity.describe = 'Describe'
t.homepage.specialactivity.backgroundPicture = 'Background Picture'
t.homepage.specialactivity.coverPicture = 'Cover Picture'
t.homepage.specialactivity.tags = 'Tags'
t.homepage.specialactivity.type = 'Type'
t.homepage.specialactivity.status = 'Status'
t.homepage.specialactivity.name = 'Name'
t.homepage.specialactivity.activity = 'Activity'
t.homepage.specialactivity.isHomePage = 'HomePage Show'
t.homepage.specialactivity.relatedTags = 'Related Tags'
t.homepage.specialactivity.Listtitle = 'List title'
t.homepage.specialactivity.Searchkey = 'Search keywords'
t.homepage.specialactivity.Catalog = 'Catalog'
t.homepage.specialactivity.alllistproduct = 'List of all products'
t.homepage.specialactivity.Catalogitemlist = 'Catalog item list'
t.homepage.specialactivity.Searchproductlist = 'Search product list'

t.merchant = {}
t.merchant.name = 'Brand'
t.merchant.intro = 'Brand Intro'
t.merchant.mobile = 'Mobile'
t.merchant.account = 'Account Detail'
t.merchant.passwd = 'Password'
t.merchant.merchantId = 'Brand ID'
t.merchant.accountList = 'Brand Account List'
t.merchant.company = 'Supplier Company'
t.merchant.logo = 'Brand Logo'
t.merchant.code = 'Brand Code'
t.merchant.email = 'E-mail'
t.merchant.nameIsExistTips = 'The current merchant name already exists, please replace one to try'
t.merchant.nameIsNotExistTips = 'Current merchant name available'
/* new */
t.merchant.brandDetailAdvertisementPicture = "Brand Detail Advert"
t.merchant.brandAdvertisementPicture = 'Home Brand Advert'
t.merchant.logoImage = 'Logo'
t.merchant.homepageImage = 'Home Advert'
t.merchant.detailImage = 'Detail Advert'

t.categorynew = {}
t.categorynew.addfirstClass = "Create a new level 1 Classification"
t.categorynew.Multilingualname = "Multilingual name"
t.categorynew.activation = "Activation"
t.categorynew.firstName = "First level classification name"
t.categorynew.firstsorting = "First level sorting"
t.categorynew.newdirectory = "New directory"
t.categorynew.Directoryname = "Directory name"
t.categorynew.Relatedcommodities = "Associated Goods"
t.categorynew.skuCount = "Number of associated SKUs"

/**共用**/
t.public = {}
t.public.set = 'Set'
t.public.settings = 'Settings'
t.public.edit = 'Edit'
t.public.clickToEdit = 'Click To Edit'
t.public.add = 'Add'
t.public.delete = 'Delete'
t.public.details = 'Details'
t.public.update = 'Update'
t.public.modify = 'Modify'
t.public.success = 'Success'
t.public.fail = 'Fail'
t.public.error = 'Error'
t.public.sort = 'Sort'
t.public.saled = 'Saled'
t.public.manage = 'Store classification management'
t.public.addcategor = 'Add a new category'
t.public.show = 'Whether to show in the category'
t.public.sort = 'Sort'
t.public.cataname = 'Category Name'
t.public.relate = 'related products'
t.public.tips = 'Tips'
t.public.operation = 'Operation'
t.public.yes = 'Yes'
t.public.no = 'No'
t.public.submit = 'Submit'
t.public.reset = 'Reset'
t.public.review = 'Review'
t.public.confirm = 'Confirm'
t.public.cancel = 'Cancel'
t.public.back = 'Back'
t.public.title = 'Title'
t.public.content = 'Content'
t.public.picture = 'Picture'
t.public.search = 'Search'
t.public.query = 'Query'
t.public.output = 'Output'
t.public.icon = 'Icon'
t.public.selectedIcon = 'Selected Icon'
t.public.askDelete = 'The attempted operation cannot be recalled, continue?'
t.public.chinese = 'Chinese'
t.public.english = 'English'
t.public.thai = 'Thai'
t.public.createTime = 'Create Time'
t.public.finishTime = 'Finish Time'
t.public.status = 'Status'
t.public.valid = 'Valid'
t.public.invalid = 'Invalid'
t.public.iSee = 'Close'
t.public.close = 'Close'
t.public.remark = 'Remark'
t.public.value = 'Value'
t.public.baseInformation = 'Base Information'
t.public.all = 'All'
t.public.name = 'Name'
t.public.numberSort = 'Please enter the bigger the number, the bigger the front row'
t.public.advert = 'Advert'
t.public.profile = 'Profile'
t.public.backgroundPicture = 'Background Picture'
t.public.Initials = 'Initials'
t.public.price = 'Price'
t.public.resetSearchKeyword = 'Reset Search Keyword'
t.public.product = 'Single product'
t.public.onShelves = 'On shelves'
t.public.offShelf = 'Off shelf'
t.public.prohibit = 'Prohibit'
t.public.enable = 'Enable'
t.public.minimumValue = 'minimum value'
t.public.maximum = 'Maximum'
t.public.userLevel = 'User level'
t.public.userLevel1 = 'Pro'
t.public.userLevel2 = 'Plus'
t.public.userLevel3 = 'Starter'
t.public.userLevel4 = 'Fans'
t.public.userLevel5 = 'Vip'
t.public.individual = 'INDIVIDUAL'
t.public.company = 'COMPANY'
t.public.skuProportion = 'Effective SKUs / total'



t.order.label = {}
t.order.label.all = 'All'
t.order.label.coupon = 'Coupon Code'
t.order.label.waitForAuditing = 'Pending Review'
t.order.label.waitForPay = 'To Be Paid'
t.order.label.waitForDelivery = 'To Be Delivered'
t.order.label.waitForReceive = 'To Be Received'
t.order.label.canceled = 'Cancel'
t.order.label.finished = 'Completed'
t.order.label.orderId = 'Order Number'
t.order.label.username = 'User Name'
t.order.label.productCode = 'Code'
t.order.label.productKeywords = 'Keyword'
t.order.label.orderDetails = 'Order details'
t.order.label.shippingDetails = 'Shipping details'
t.order.label.invoice = 'Invoice'
t.order.label.billname = 'Billing Name'
t.order.label.billaddress = 'Billing Address'
t.order.label.needInvoice = 'Request invoice by post'
t.order.label.companyTaxno = 'Company Tax Number'
t.order.label.individualTaxno = 'Tax ID'
t.order.label.paymentDetails = 'Payment details'
t.order.label.orderCode = 'Order Number'
t.order.label.orderChannel = 'Order Channel'
t.order.label.customerName = 'Customer Name'
t.order.label.priceTier = 'Price Tier'
t.order.label.paymentStatus = 'Payment Status'
t.order.label.paymentMethods = 'PaymentMethods'
t.order.label.createTime = 'Order Submission Time'
t.order.label.confirmTime = 'Order Confirmation Time'
t.order.label.finishTime = 'Order Completion Time'
t.order.label.productInfo = 'Product Information'
t.order.label.productName = 'Product Name'
t.order.label.productProperty = 'Product Properties'
t.order.label.orderInfo = 'Order Information'
t.order.label.logisticsInfo = 'Logistics Information'
t.order.label.orderStatus = 'Order Status'
t.order.label.contactName = 'Receiver'
t.order.label.address = 'Address'
t.order.label.mobile = 'Phone'
t.order.label.contractNo = 'TeL'
t.order.label.receiveRemark = 'Message'
t.order.label.companyName = 'Company'
t.order.label.historyOrder = 'Historical Order'

t.order.label.operation = 'Operation'
t.order.label.productType = 'Types of Goods'
t.order.label.count = 'Total Quantity'
t.order.label.clickToShowPrefix = 'Click to check(Totally:'
t.order.label.clickToHidePrefix = 'Click to hide(Totally:'
t.order.label.clickToShowSuffix = ')'
t.order.label.clickToHideSuffix = ')'
t.order.label.copy = 'Copy'
t.order.label.ViewOrderDetail = 'View Order Details'
t.order.label.confirmArriveDate = 'Send the Delivery Date'
t.order.label.confirmPaid = 'Confirm the Payment'
t.order.label.confirmPaidFront = 'Confirm Prepayment'
t.order.hint = {}
t.order.hint.copySuccess = 'Successful'
t.order.hint.copyFail = 'Failed'
t.order.hint.ordernumtip = 'Please enter the correct quantity'
t.order.hint.arriveDateEmpty = 'Please choose the delivery date'
t.order.hint.freightPlease = 'Please input the freight'
t.order.label.productInfoAndPrice = 'Commodity & Unit Orice'
t.order.label.productCount = 'Quantity'
t.order.label.productPrice = 'Amount'

t.order.label.goodsAmount = 'Sub total'
t.order.label.discountSub = 'Discount Subtotal'
t.order.label.freightAmount = 'Delivery fee'
t.order.label.freightFree = 'Free'
t.order.label.transFee = 'Transaction fee'
t.order.label.totalAmount = 'Total Amount'

t.order.confirmContent = {}
// t.order.confirmContent.level10 = 'Dear customer, \n  According to the order submitted by you, we confirm the estimated delivery date according to the estimated delivery and logistics time of the goods:\n \n                                                                             #ARRIVEDATE# \n \n  In view of your good credit, we will You pay in advance, please prepare cash or credit card payment at the time of delivery. '
// t.order.confirmContent.level11 = t.order.confirmContent.level10
// t.order.confirmContent.level1 = t.order.confirmContent.level11
// t.order.confirmContent.level20 = 'Dear customer, \n  According to the order submitted by you, we confirm the estimated delivery date according to the estimated delivery and logistics time of the goods:\n \n                                                                             #ARRIVEDATE# \n \n  In view of your good credit, please go to #PAYDAYS# days Within the payment, the remaining payment will be made up after the goods are delivered, otherwise the order will be cancelled automatically. '
// t.order.confirmContent.level21 = t.order.confirmContent.level20
// t.order.confirmContent.level30 = 'Dear customer, \n  According to the order submitted by you, we confirm the estimated delivery date according to the estimated delivery and logistics time of the goods:\n \n                                                                             #ARRIVEDATE# \n \n  In view of your good credit, please go to #PAYDAYS# days Within the prepayment ฿ #AMOUNT#, the remaining payment will be made up after the goods are delivered, otherwise the order will be cancelled automatically. '
// t.order.confirmContent.level31 = t.order.confirmContent.level30
t.order.label.selectArriveDate = 'Estimate delivery date'
t.order.label.Enterfreight = 'Enter freight'
t.order.label.modifyArriveDate = 'Update Delivery Date'
t.order.label.modifyContent = 'Change Default Message'
t.order.label.modifyPayDays = 'Change Default Payment Days'
t.order.label.modifyPayAmountRate = 'Change Default Payment Ratio'
t.order.label.selectCountPrefix = 'Totally...'
t.order.label.selectCountSuffix = ',Batch Operation'
t.order.label.outOfStock = 'Out of Stock'
t.order.label.halfConfirm = 'Partial Shipment'
t.order.label.confirm = 'Confirm'
t.order.label.cancel = 'Cancel'
t.order.label.remark = 'Notes'
t.order.label.sendMessage = 'Message'
t.order.label.confirmOrder = 'Order Confirm'
t.order.label.step = 'Schedule'
t.order.label.confirmToDeliver = 'Confirm'

t.order.hint.hadPaidFront = 'Advance Payment Detail'
t.order.hint.hadPaidRest = 'Whether the user has paid the final payment'
t.order.hint.hadPaid = 'Whether the user has Paid'
t.order.label.hadPaid = 'Paid'
t.order.label.payAmount = 'Payment Amount'
t.order.label.paymenntTip = 'Upload payment voucher'

t.order.label.cancelOrder = 'Abort Order'

t.order.unit = {}
t.order.unit.productType = 'Kinds'
t.order.unit.productCount = 'Piece'

t.order.search = {}
t.order.search.inputHint = 'Please Input'
t.order.search.selectHint = 'Please Choose'

t.order.step = {}
t.order.step.createOrder = 'Submit Order'
t.order.step.confirmOrder = 'Confirm'
t.order.step.paid = 'Paid'
t.order.step.confirmPaidFront = 'Advance Payment'
t.order.step.confirmPaidRest = 'Final Payment'
t.order.step.confirmPaid = 'To Pay'
t.order.step.delivered = 'Delivery'
t.order.step.receipt = 'Delivered'
t.order.step.finished = 'Complete'
t.order.dearCustomerHello = 'Dear customer, hello!'
t.order.orderamendedasfollows = 'The order is amended as follows:'
t.order.changeinto = 'Change Into'

t.order.COMMITED = 'Submitted'
t.order.WAP = 'To Be Prepaid'
t.order.WFP = 'Pending Payment'

t.coupon = {}
t.coupon.tabAll = 'All'
t.coupon.tabStart = 'In progress'
t.coupon.tabNotStart = 'Not started'
t.coupon.tabDisabled = 'Disabled'
t.coupon.tabEnd = 'Expired'
t.coupon.typeCash = 'Cash'
t.coupon.typeDiscount = 'By percentage'
t.coupon.typeFull = 'Fix amount'
t.coupon.typeNo = 'Long-term'
t.coupon.typeDay = 'Day'
t.coupon.typeDate = 'Date'
t.coupon.orderNum = 'Order Number'
t.coupon.type = 'Type'
t.coupon.timeType = 'Time Type'
t.coupon.status = 'Status'
t.coupon.couponName = 'Promotion Name'
t.coupon.couponTime = 'Time:'
t.coupon.couponTotal = 'Total number of coupon codes:'
t.coupon.couponRepeat = 'Number of repetitions:'
t.coupon.couponType = 'Type:'
t.coupon.couponAmount = 'Amount:'
t.coupon.couponUsed = 'Used times:'
t.coupon.couponUnused = 'Remaining available times:'
t.coupon.record = 'Use record:'

t.coupon.discountTable = {}
t.coupon.discountTable.quantifier = 'Unit'
t.coupon.discountTable.nameText = 'Name'
t.coupon.discountTable.couponType = 'Type'
t.coupon.discountTable.createTime = 'Create time'
t.coupon.discountTable.couponTimeType = 'Time Type'
t.coupon.discountTable.startDate = 'Start time'
t.coupon.discountTable.endDate = 'End time'
t.coupon.discountTable.status = 'Review status'
t.coupon.discountTable.status2 = 'Activity status'
t.coupon.discountTable.statusDisable = 'Disabled'
t.coupon.discountTable.statusPending = 'Pending'
t.coupon.discountTable.statusEnd = 'Expired'

t.coupon.discountTableDlg = {}
t.coupon.discountTableDlg.code = 'Used coupon code'
t.coupon.discountTableDlg.username = 'User name'
t.coupon.discountTableDlg.name = 'User nickname'
t.coupon.discountTableDlg.traceNo = 'Order number'
t.coupon.discountTableDlg.status = 'Order status'
t.coupon.discountTableDlg.beforeCouponAmount = 'Price before using coupon code'
t.coupon.discountTableDlg.amount = 'Total order amount(฿)'
t.coupon.discountTableDlg.codeHint = 'Please enter the coupon code'
t.coupon.discountTableDlg.phoneHint = 'Please enter the user number'
t.coupon.discountTableDlg.pay_FULL = 'Fix amount'
t.coupon.discountTableDlg.pay_DISCOUNT = 'By percentage'
t.coupon.discountTableDlg.pay_CASH = 'Cash'
t.coupon.discountTableDlg.piece = 'Piece'

t.coupon.recordTableDlg = {}
t.coupon.recordTableDlg.BrowseRecordBtn = 'View coupon code list'
t.coupon.recordTableDlg.th_couponCode = 'Coupon code'

t.coupon.form = {}
t.coupon.form.baseInfo = 'Promotion Information'
t.coupon.form.activityEn = 'Promotion name'
t.coupon.form.activityTh = 'Promotion name (TH)'
t.coupon.form.activityHint = 'Please enter the promotion name'
t.coupon.form.dayStart = 'Start Time'
t.coupon.form.dayKeep = 'Duration (day)'
t.coupon.form.timeline = 'Promotion time'
t.coupon.form.ever = 'Permanent'
t.coupon.form.minCount = 'Minimum Basket Price'
t.coupon.form.maxCount = 'Maximum Discount Price'
t.coupon.form.maxCountY = 'Set amount'
t.coupon.form.maxCountN = 'No limit'
t.coupon.form.day = 'Days'
t.coupon.form.date = 'Date'
t.coupon.form.param = 'Promotion Details'
t.coupon.form.promotion = 'Promotion type'
t.coupon.form.full = 'Fix amount'
t.coupon.form.cash = 'Cash'
t.coupon.form.amount = 'Discount amount'
t.coupon.form.range = 'Scope of use'
t.coupon.form.allProduct = 'All products'
t.coupon.form.productItem = 'Specific SKU'
t.coupon.form.brand = 'Brand'
t.coupon.form.brandLabel = 'Brand'
t.coupon.form.classify = 'Category'
t.coupon.form.classifyLabel = 'Sub-category'
t.coupon.form.fullAmount = 'Minimum basket price'
t.coupon.form.couponInfo = 'Coupon Code Information'
t.coupon.form.couponType = 'Coupon code type'
t.coupon.form.single = 'Single coupon code'
t.coupon.form.multiple = 'Multiple coupon codes'
t.coupon.form.couponRule = 'Number naming rule'
t.coupon.form.fixed = 'Fixed'
t.coupon.form.fore = 'Fixed prefix'
t.coupon.form.rear = 'Fixed suffix'
t.coupon.form.rand = 'Random'
t.coupon.form.fixHint = 'Discount name'
t.coupon.form.discount = 'By percentage'
t.coupon.form.discountAmount = 'Percentage'
t.coupon.form.partialHint = 'Please enter the fixed part'
t.coupon.form.quantityTotal = 'Number of coupon codes'
t.coupon.form.quantityTotalHint = 'Please enter the coupon code quantity'
t.coupon.form.couponRepeat = 'Usage times'
t.coupon.form.couponRepeat1 = 'Repeated use'
t.coupon.form.couponRepeat2 = 'Single use (for single user)'
t.coupon.form.search = 'Product name / Barcode'
t.coupon.form.canAdd = 'Can be added'
t.coupon.form.add = 'Add'
t.coupon.form.addAll = 'Add all'
t.coupon.form.added = 'Added'
t.coupon.form.remove = 'remove'
t.coupon.form.removeAll = 'Remove all'

t.member.label = {}
t.member.label.audit = 'User Verify'
t.member.label.username = 'User Name'
t.member.label.contactName = 'Contact Name'
t.member.label.accountDays = 'Account Period'
t.member.label.firstName = 'First Name'
t.member.label.firstName = 'Last Name'
t.member.label.nickName = 'Nick Name'
t.member.label.gender = 'Gender'
t.member.label.birth = 'Date of birth'
t.member.label.email = 'Email'
t.member.label.address = 'Address'
t.member.label.province = 'Province'
t.member.label.city = 'City'
t.member.label.post = 'Zipcode'
t.member.label.mobile = 'Phone Number'
t.member.label.phoneNo = 'TeL.'
t.member.label.companyName = 'Company Name'
t.member.label.userLevel = 'User Level'
t.member.label.createTime = t.user.createDate
t.member.label.status = t.user.status
t.member.label.operation = t.user.status
t.member.label.payType = 'Pay Type'
t.member.label.remark = 'Remark'
t.member.label.male = 'Male'
t.member.label.female = 'Female'
t.member.label.unknow = 'Unknown'
t.member.label.pleaseEnter = 'Please enter'
t.member.label.pleaseEnterCert = 'Please upload certificate files'
t.member.value = {}
t.member.value.statusY = 'Normal'
t.member.value.statusN = 'Disable'
t.member.value.statusU = 'To be reviewed'
t.member.value.statusR = 'Rejected'
t.member.value.statusINIT = 'Information to be improved'
t.member.label.showDetail = 'Check Details'
t.member.label.createUser = 'Create User'
t.member.label.admit = 'Approved'
t.member.label.refuse = 'Reject'
t.member.label.save = 'Save changes'
t.member.label.personal = 'Personal Information'
t.member.label.personalReview = 'Personal Registration Review'
t.member.label.personalAccount = 'Personal account information'
t.member.label.personalInfo = 'Personal Infomation'
t.member.label.company = 'Company Information'
t.member.label.companyReview = 'Company Registration Review'
t.member.label.companyAccount = 'Company account information'
t.member.label.companyInfo = 'Company Info'
t.member.label.companyContact = 'Company Contact'


t.order.label.hadReceived = 'User has received the goods'
t.order.hint.hadReceived = 'Whether the user has received the goods'
t.order.hint.minProductCountLimit = 'Product data is less than the minimum order quantity'
t.member.label.baseInfo = 'User basic information'
t.member.label.platformId = 'Platform ID'
t.member.label.companyName = 'Company name'
t.member.label.contractName = 'Contact name'



t.member.label.mobile = 'Contact phone number'
t.member.label.phoneNo = 'Fixed phone'
t.member.label.email = 'Email'
t.member.label.platformInfo = 'User platform information'
t.member.label.username = 'User account'
t.member.label.password = 'User password'
t.member.label.level = 'User level'
t.member.label.otherInfo = 'Other information'
t.member.label.totalAmount = 'Total transaction amount'
t.member.label.orderCount = 'Total number of orders placed'
t.member.label.availOrderCount = 'Number of valid orders'
t.member.label.lastOrderTime = 'Last transaction time'
t.member.label.lastOrderAmount = 'Last order amount (?)'
t.member.label.invoice = 'Invoice Information'
t.member.label.oper = 'Operation'
t.member.label.operCreate = 'SAP Confirm Creation'
t.member.label.operView = 'View/Modify'
t.member.label.invoiceUncommit = 'Uncommitted'
t.member.label.invoiceNormal = 'Normal'
t.member.label.invoiceReview = 'Review'
t.member.label.invoiceStateY = 'Normal'
t.member.label.invoiceStateN = 'Disabled'
t.member.label.invoiceTitle = 'User Billing Information'
t.member.label.sapConfirm = 'SAP Confirm Creation';
t.member.label.reviewConfirm = 'Confirm Creation';
t.member.label.review = 'Invoice Document';
t.member.label.companyProfile = 'Company Profile';
t.member.label.certifiedVat = 'Certified Copy of VAT Registration Certificate (Por Por 20 or 01 or 09)';
t.member.label.certifiedRegister = 'Certified Copy of the Certificate of Registration Issued by Ministry of Commerce not more than 3 months before application submission date';
t.member.label.certifiedIdCard = 'Certified Copy of ID Card of Company’s Authorize Person(s)';
t.member.label.shareholders = 'Copy of the shareholders list of the company';
t.member.label.taxNo = 'Tax id (ID number)'


t.order.label.hadReceived = 'User has received the goods'
t.order.hint.hadReceived = 'Whether the user has received the goods'
t.order.hint.minProductCountLimit = 'Product data is less than the minimum order quantity'
t.member.label.baseInfo = 'User basic information'
t.member.label.platformId = 'Platform ID'
t.member.label.companyName = 'Company name'
t.member.label.companyTaxno = 'Tax Number'
t.member.label.contractName = 'Contact name'
t.member.label.mobile = 'Contact phone number'
t.member.label.phoneNo = 'Landline'
t.member.label.platformInfo = 'User platform information'
t.member.label.username = 'User account'
t.member.label.password = 'User password'
t.member.label.level = 'User level'
t.member.label.otherInfo = 'Other information'
t.member.label.totalAmount = 'Total transaction amount'
t.member.label.orderCount = 'Total number of orders placed'
t.member.label.availOrderCount = 'Effective Order'
t.member.label.lastOrderTime = 'Last order time'
t.member.label.lastOrderAmount = 'Last order amount(฿)'
t.member.label.orderProductCount = 'Quantity of goods purchased'
t.member.label.refuse = 'Refuse'
t.member.label.agree = 'Agree'

t.category = {}
t.category.label = {}
t.category.label.category = 'Category'
t.category.label.categoryName = 'Name'
t.category.label.append = 'Append'
t.category.label.relation = 'Relation'
t.category.label.unrelation = 'Unrelation'
t.category.label.update = 'Update'
t.category.label.delete = 'Delete'
t.category.label.sort = 'Sort'
t.category.label.advert = 'Advert'
t.category.label.jump = 'Jump can be set'
t.category.label.cover = 'Cover'
t.category.label.nameLevel1 = 'Catalog: A-Level'
t.category.label.nameLevel2 = 'Catalog: B-Level'
t.category.label.nameLevel3 = 'Catalog: C-Level'

t.category.label.relationDetail = 'Relation Detail'
t.public.filter = 'Filter'
t.category.label.batchAddPrefix = 'Batch Operations: Selected '
t.category.label.skuProportion = 'Effective SKUs / Total'

t.category.label.off = 'Off'
t.category.label.on = 'On'
t.category.prd = {}
t.category.prd.inputCatName = 'Catalog name'
t.category.prd.stateY = 'Normal'
t.category.prd.stateN = 'Removed'
t.category.prd.search = 'Search'
t.category.prd.add = '+Add'
t.category.prd.tNo = 'Serial number'
t.category.prd.tName = 'Catalog name'
t.category.prd.tCount = 'Product quantity'
t.category.prd.tState = 'Status'
t.category.prd.tOper = 'Operation'
t.category.prd.dTitle = 'Operation'
t.category.prd.dNameTh = 'Catalog name (TH)'
t.category.prd.dNameEn = 'Catalog name (EN)'
t.category.prd.dState = 'Status'
t.category.prd.dCreate = 'Create'
t.category.prd.dModify = 'Modify'
t.category.prd.dCancel = 'Cancel'
t.category.brand = {}
t.category.brand.stateY = 'Can be added'
t.category.brand.stateN = 'Added'
t.category.brand.tName = 'Brand name'
t.category.brand.tImg = 'Brand image'
// t.category.brand.tContact ='Brand contact'
t.category.brand.tTel = 'Phone'
t.category.brand.tMobile = 'Mail'
t.category.brand.tSku = 'Effective sku/Total sku'
t.category.brand.tSort = 'Sort'
t.category.brand.tOper = 'Operation'
t.category.brand.tOperRemove = 'Remove'
t.category.brand.tOperAdd = 'Add'
/* new */
t.category.brand.tAdvertImg = 'Advert Pic'

t.product.label = {}
t.product.label.editPrice = 'Price & Stock'
t.product.label.priceAndStock = 'Price And Stock'
t.product.label.priceLevel2 = 'Plus Price'
t.product.label.priceLevel1 = 'Pro Price'
t.product.label.priceLevel3 = 'Starter Price'
t.product.label.priceLevel4 = 'Fans Price'
t.product.label.priceLevel5 = 'VIP Price'
// t.product.label.priceLevel21 = 'Price For vip经销商有账期'
// t.product.label.priceLevel30 = 'Price For 普通企业客户无账期'
// t.product.label.priceLevel40 = 'Price For vip企业客户无账期'
t.product.label.priceLevel10 = 'Distributor'
t.product.label.priceLevel11 = 'Distributor (Credit terms)'
t.product.label.priceLevel20 = 'VIP Distributor'
t.product.label.priceLevel21 = 'VIP Distributor (Credit terms)'
t.product.label.priceLevel30 = 'Corporate'
t.product.label.priceLevel40 = 'VIP Corporate'
t.product.label.name = 'Name'
t.product.label.multiLangSetting = 'multiLangSetting'
t.product.label.category = 'Category'
t.product.label.catalog = 'Platform category'
t.product.label.merchantCatalog = 'MerchantCatalog'
t.product.label.jumpToCatalogManage = 'jumpToCatalogManage'
t.product.label.manufacturer = 'manufacturer'
t.product.label.selectSpecially = 'selectSpecially'
t.product.label.supplier = 'Supplier'
t.product.label.keyword = 'Keyword'
t.product.label.longDescription = 'Long Description'
t.product.label.clickToAddSku = 'clickToAddSku+'
t.product.label.clickToAddSkuOption = 'clickToAddOption+'
t.product.label.skuName = 'Sku name'
t.product.label.propertyName = 'Option name'
t.product.label.skuValue = 'Option value'
t.product.label.status = 'Goods status'
t.product.label.clickToAddItem = 'Click To Add Goods+'
t.product.label.hint = 'Description'
t.product.label.productSpecification = 'Specification'
t.product.label.productAfterSale = 'After Sale'
t.product.label.productStandardQuestion = 'Standard Question'
t.product.label.copyItem = 'Copy'
t.product.label.operationfee = 'Distribution operation fee'
t.product.label.shortDesc = 'Short Description'
t.product.item.name = 'Goods Name'
t.product.hint = {}
t.product.hint.skuPropertyName = 'Option Name'
t.product.hint.skuValue = 'Option Value'

t.product.item = {}
t.product.item._ = 'ProductItem'
t.product.item.list = 'ProductItem List'
t.product.item.keyword = 'Keyword'
t.product.item.activate = 'Activate'
t.product.item.id = 'Platform ID'
t.product.item.name = 'ProductItem Name'
t.product.item.describe = 'Describe'
t.product.item.barCode = 'BarCode'
t.product.item.code = 'SKU'
t.product.item.stock = 'Stock'
t.product.item.price = 'Promotion Price'
t.product.item.agentPrice = 'Agent Price'
t.product.item.projectPrice = 'Project Price'
t.product.item.originalPrice = 'SRP Price'
t.product.item.priceCost = 'Cost Price'
t.product.item.operation = 'Sub Product Action'
t.product.item.off = 'Off'
t.product.item.on = 'On'
t.product.item.copy = 'Duplicate'
t.product.item.freightCalculate = 'Freight Calculate'
t.product.item.freightCalculateValue = 'Freight Calculate Value'
t.product.item.weight = 'Weight'
t.product.item.volume = 'Volume'
t.product.item.big = 'Big'
t.product.item.priceAndStock = 'Price & Stock'
t.product.item.pictureAndVideo = 'Picture & Video'
t.product.item.picture = 'Picture (1)'
t.product.item.detailPicture = 'Picture Details (6)'
t.product.item.video = 'Video (1)'
t.product.item.videourl = 'Video URL'
t.product.item.extendValue = 'Color Code'
t.product.item.colorPicker = 'Color Picker'
t.product.item.increment = 'Increment'
t.product.item.attribute = 'Attribute'
t.product.item.attributeValue = 'Attribute Value'
t.product.item.attributeName = 'Attribute Name'

// t.product.label.originalprice = 'Retail Price'
t.product.label.originalprice = 'SRP'
t.product.label.priceCost = 'Cost Price'

t.product.label.total = 'Stock'
t.product.label.stock = 'Stock update'
t.product.label.overseasTotal = 'Overseas stock'
t.product.label.overseasStock = 'Overseas update'
t.product.label.minCount = 'Min Order Quantity'
t.product.itemAdded = 'Item added'
t.product.canAddGoods = 'Can Add Goods'


t.catalog.merchant = {}
t.catalog.merchant.itemAdded = 'Supplier Added'
t.catalog.merchant.canAddItems = 'Can Add Supplier'

t.merchant.label = {}
t.merchant.label.name = 'Supplier Name'
t.merchant.label.company = 'Company'
t.merchant.label.intro = 'Intro'
t.merchant.label.desc = 'Desc'
t.merchant.label.mobile = 'Mobile'
t.merchant.label.email = 'Email'
t.merchant.suppliernameTip = 'Please enter the supplier name'


t.product.Pricerange = 'Price range'
t.product.Inventoryinterval = 'Inventory interval'
t.category.commodityCategory = 'Commodity category'

// t.member.label.accountDays = 'Pay delay(days)'
t.order.label.fee = 'Handling Fee or Bankcharge'
t.member.label.modifyPassword = 'Modify password'
t.member.label.verifyPassword = 'Verify password'
t.validate.passwordNotMatch = 'The verify password is not match'

t.user.accountDayPrefix = '-'
t.user.accountDaySuffix = 'Days'
t.member.label.accountDays = 'Credit terms'
t.member.label.settingAccountDaysSuffix = ' Day'
t.member.label.accountDaysSuffix = 'Days credit terms'
t.member.label.zeroAccountDays = 'No credit terms'
t.order.label.outtimeForPayPrefix = 'Please advise the payment as soon as possible, only '
t.order.label.outtimeForPaySuffix = ' from deadline'
t.member.label.channel = 'Channel'
t.member.label.businessLeader = 'Business Leader'
t.member.label.businessMobile = 'Business Mobile'
t.member.label.businessEmail = 'Business Email'
t.member.label.businessNumber = 'Business Number'
t.order.label.prepaymentAmount = 'Advance Payment Amount'
t.order.label.finalPaymentAmount = 'Final payment Amount'
t.order.label.paid = 'Paid'
t.order.label.unpaid = 'Unpaid'
t.order.label.paidStatus = 'Payment Status'
t.product.item.overseasTotal = 'Overseas stock'
t.product.label.customerLevel = 'Customer Level'

t.product.label.all = 'All'
t.product.label.waitForAuditing = 'Auditing'
t.product.label.onShelf = 'On Shelf'
t.product.label.offShelf = 'Off Shelf'
t.product.label.deleted = 'Deleted(Keep 10 Days)'
t.product.label.warningList = 'Warning List'

t.product.label.name = 'Name'
t.product.label.Sku = 'SKU'
t.product.label.SkuName = 'SKU Desc'
t.product.label.price = 'Price'
t.product.label.saled = 'Saled Count'
t.product.label.publish = 'Status'
t.product.label.operation = 'Operation'
t.product.label.productId = 'ID'
t.product.label.merchantId = 'Supplier'
t.product.search = {}
t.product.search.selectHint = 'Select'
t.product.search.inputHint = 'Input'
t.product.label.productName = 'Product Name'
t.product.label.minQuantity = 'Minimum order quantity'
t.product.Timeofreceipt = 'Time of receipt'
t.product.Cancellationtime = 'Cancellation time'
t.product.Operatingfee = 'Operating fee'
t.product.Totalorderprice = 'Total order price'
t.product.Checkoutstatus = 'Checkout status'
t.product.Checkouttime = 'Checkout time'
t.product.priceVal = 'Is the price confirmed as 0?'

t.order.payType = 'Payment Methods'
t.order.payMethod = 'Payment Method'
t.order.ptKBANKMCC = 'Debit / Credit Card'
t.order.ptKBANKQR = 'Prompt pay'
t.order.ptOFFLINE = 'Bank Transfer'
t.order.ptBANKTRANSFER = 'Bank Transfer'
t.order.amount = {}
t.order.label.amountUnmatch = 'Order Amount Unmatch'
t.order.label.shopName = 'Shop'
t.order.label.stockInside = 'Stock In Thailand'
t.order.label.stockOutside = 'Stock In Overseas'
t.order.label.stockInsidecope = 'Pieces in Thailand'
t.order.label.stockOutsidecope = 'Pieces in Overseas'
t.merchant.certificatePicture = 'Certificate Picture'

t.brandPage = {}
t.brandPage.addBrand = 'Add Brand'
t.brandPage.brand = 'Brand'
t.brandPage.show = 'Status'
t.brandPage.Brandname = 'Brand name'
t.brandPage.Brandlogo = 'Brand logo'
t.brandPage.SKUstotal = 'Number of valid SKUs/total number of SKUs'
t.brandPage.Newbrand = 'New brand'
t.brandPage.Modifybrand = 'Modify brand'
t.brandPage.Dummyvalue = 'Dummy value'
t.brandPage.Editfirstcategory = 'Edit the first level category--'
t.brandPage.Addnewcategory = 'Add a new category'
t.brandPage.Clickicon = 'Click the effect icon'
t.brandPage.iconnotclicked = 'The effect icon is not clicked'
t.brandPage.showinthecategory = 'Whether to show in the category'
t.brandPage.Adspictures = 'Ads pictures'
t.brandPage.Editsendcategory = 'Edit secondary classification --'
t.brandPage.Editsendclass = 'Edit secondary classification'
t.brandPage.Edit = 'Edit'
t.brandPage.Addsendcategory = 'Add'
t.brandPage.Editthildcategory = 'Edit three-level classification --'
t.brandPage.Addthildcategory = 'New three-level classification'
t.brandPage.Relatedinformation = 'Related information'
t.brandPage.relatedproducts = 'Related products'
t.brandPage.CategoryName = 'Category Name'
t.brandPage.videoformat = 'Please upload the correct video format'
t.brandPage.recommandSize1 = 'The recommended size is more than 800X800px, png, jpg format, no more than 5M'
t.brandPage.recommandSize2 = 'recommended size 1080 X 320px or more, png, jpg format, no more than 5M'
t.brandPage.recommandSize3 = 'The recommended size is more than 800X800px, png, jpg format, no more than 5M'
t.brandPage.recommendedProducts = 'Recommended products'

t.brandPage.sider = {}
t.brandPage.sider.inputName = 'Please enter the brand name'
t.brandPage.sider.brandName = 'brand name'
t.brandPage.sider.brandImg = 'Brand Image'
t.brandPage.sider.brandAdvImg = 'Brand Ad'
t.brandPage.sider.brandContact = 'Brand Contact'
t.brandPage.sider.brandPhone = 'Phone'
t.brandPage.sider.skuratio = 'Effective SKU / Total SKU'
t.brandPage.sider.brandMail = 'Mail'
t.brandPage.sider.sort = 'sort'

t.order.label.deliveryService = 'Delivery service'
t.order.label.edit = 'Edit'
t.order.label.downloadOrderLabel = 'Download order label'
t.order.label.uploadOrderLabel = 'Upload order label'
t.order.label.confirmEdit = 'Confirm Edit'
t.order.label.shippedByRPP = 'Shipped by RPP'
t.order.label.sellerOwnFleet = 'Pick Up'
t.order.label.platform = 'Platform'
t.order.label.carrier = 'Courier'
t.order.label.trackingNumber = 'Tracking number'
t.order.label.deliveryservicesError = 'Please choose delivery services'
t.order.label.deliveryplatformidError = 'Please choose platform'
t.order.label.deliverycarrieridError = 'Please choose courier'
t.order.label.deliverytrackingError = 'Please fill in tracking number'
t.uploader.labelFileError = 'Accepted file formats PDF, JPG, JPEG, PNG only'
t.order.label.labelFileNullError = 'Please upload order label'
t.uploader.pdfSizeExceed5MB = 'Exceed size limit 5MB'
t.order.label.labelFile = 'Order label file'

t.prompt.dimAbortOrderTitle = 'Oops!'
t.prompt.dimAbortOrderDesc = 'Unable to abort order. The order has been delivered.'
t.prompt.dimAbortOrderDetail = '* Please contact warehouse team.'

t.sys.cdms = {}
t.sys.cdms.userName = 'User Name'
t.sys.cdms.role = 'Role'
t.sys.cdms.syncTime = 'Sync Time'
t.sys.cdms.status = 'Status'
t.prompt.cdmsDesc = 'Confirm DISABLE sync order to CDMS'
t.prompt.cdmsTitle = 'Alert'

export default t
